import {
  AprovadorAlternativoProps,
  AprovadorAlternativoResultProps,
  deleteAprovadorAlternativo,
  getAllAprovadorAlternativo,
  postAprovadorAlternativo
} from '@app/api/naoPrevistos/aprovadorAlternativo';
import {
  ColaboradoIntegracaoOuColaboradoIntegracaoAlternativo,
  ColaboradorTableProps,
  getAllColaborador
} from '@app/api/naoPrevistos/naoConformidadeColaboradoIntegracao';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { compareText, compareTypeNumber } from '@app/helpers/comparators';


import { hasPermission } from '@app/helpers/permissions';
import {
  FormSubmitButton,
  GridView,
  MasterDetailForm,
  SimpleView,
  Widget,
  Button,
  Table,
  ColumnProps,
  FormatText,
  FormInput
} from '@digital/ui';
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import ModalColaborador from './modalColaborador';
import { Steps, Col, Row, Tooltip } from 'antd';


const AprovadorAlternativo = () => {

  const [listResult, setListResult] = useState<AprovadorAlternativoResultProps[] | undefined>([])
  const [initialValue, setInitialValue] = useState<AprovadorAlternativoProps>({} as AprovadorAlternativoProps)
  const [listColaboradores, setListColaboradores] = useState<ColaboradorTableProps[]>([])
  

  const post = (value: AprovadorAlternativoProps) => {
    postAprovadorAlternativo(value)
      .then((result) => {
        if (result && result.valid) {
          setInitialValue({
            colaboradoIntegracaoId: '',
            colaboradoIntegracaoAlternativoId: '',
            colaboradoIntegracaoNome: '',
            colaboradoIntegracaoAlternativoNome: '',
          } as AprovadorAlternativoProps)
        }
        getAll();
      });
  }

  const hasDeletar = (id: string) => {
    deleteAprovadorAlternativo(id)
      .then((result) => {
        getAll();
      });
  }

  const getAll = () => {
    getAllAprovadorAlternativo().then((result) => {
      if (result) {
        result.map((item, index) => {
          item.numeroLinha = index + 1;
        })
      }
      setListResult(result);
    });
  }

  const getAllColaboradorIntegracao = () => {
    getAllColaborador()
      .then((result) => {
        if (result) {
          result.map((item, index) => {
            item.numeroLinha = index + 1;
          })

          setListColaboradores(result);
        }
      });
  }

  useEffect(() => {
    getAll();
    getAllColaboradorIntegracao();
  }, []);

  const colluns = () => {
    let colluns: ColumnProps<AprovadorAlternativoResultProps>[] = new Array();

    colluns.push(
      {
        title: 'N',
        dataIndex: 'numeroLinha',
        sorter: (a, b) => compareTypeNumber(a.numeroLinha, b.numeroLinha),
      });

    colluns.push(
      {
        title: 'Aprovador',
        dataIndex: 'colaboradoIntegracaoNome',
        ...mountFormFilterDropDown('colaboradoIntegracaoNome', 'Pesquisar'),
        sorter: (a, b) => compareText(a.colaboradoIntegracaoNome, b.colaboradoIntegracaoNome),
      });

    colluns.push(
      {
        title: 'Aprovador Alternativo',
        dataIndex: 'colaboradoIntegracaoAlternativoNome',
        ...mountFormFilterDropDown('colaboradoIntegracaoAlternativoNome', 'Pesquisar'),
        sorter: (a, b) => compareText(a.colaboradoIntegracaoAlternativoNome, b.colaboradoIntegracaoAlternativoNome),
      });

    colluns.push({
      title: `Ação`,
      align: 'center',
      render: (text, row, index) => {
        return (
          <>
            <Button
              onClick={() => hasDeletar(row.id)}
              icon="commons-delete"
              confirm="Deseja realmente excluir este registro?"
              okText="Excluir"
            />
          </>
        );
      },
    });

    return colluns;
  }

  const validationSchema = Yup.object().shape({
    colaboradoIntegracaoId: Yup.string().required('Aprovador deve ser informado'),
    colaboradoIntegracaoAlternativoId: Yup.string().required('Aprovador Alternativo deve ser informado'),
  });


  const onChangeInicialValue = (value: ColaboradorTableProps, enumTipoAlteracao: ColaboradoIntegracaoOuColaboradoIntegracaoAlternativo) => {

    let formInicial = { ...initialValue };

    switch (enumTipoAlteracao) {
      case ColaboradoIntegracaoOuColaboradoIntegracaoAlternativo.ColaboradoIntegracao:
        formInicial.colaboradoIntegracaoId = value.id;
        formInicial.colaboradoIntegracaoNome = `${value.register} - ${value.name}`;
        break;
      case ColaboradoIntegracaoOuColaboradoIntegracaoAlternativo.ColaboradoIntegracaoAlternativo:
        formInicial.colaboradoIntegracaoAlternativoId = value.id;
        formInicial.colaboradoIntegracaoAlternativoNome = `${value.register} - ${value.name}`;
        break;
    }
    setInitialValue(formInicial);
  }

  return (<>
    <SimpleView >
      <GridView
        noform>
        <MasterDetailForm
          validationSchema={validationSchema}
          initialValues={initialValue}
          onSubmit={values => {
            post(values);
          }}>
          <Widget
            actions={[
              hasPermission(['NAO_PREVISTO_APROVADOR_ALTERNATIVO_CADASTRAR']) && (
                <FormSubmitButton
                  type="default">
                  <FormatText id="ui.commons.save" uppercase />
                </FormSubmitButton>),
            ]}>
            <Row style={{ display: 'flex', alignItems: 'center' }}>
              <Col span={10}>
                <FormInput
                  label="Aprovador"
                  name="colaboradoIntegracaoId"
                  disabled
                  value={initialValue ? initialValue.colaboradoIntegracaoNome : ''}
                />
              </Col>
              <Col span={1}>
                <ModalColaborador
                  colaboradorTableProps={listColaboradores}
                  definirValorColoborador={(value) => {
                    if (value) {
                      onChangeInicialValue(value, ColaboradoIntegracaoOuColaboradoIntegracaoAlternativo.ColaboradoIntegracao);
                    }
                  }}
                />
              </Col>

              <Col span={10}>
                <FormInput
                  label="Aprovador Alternativo"
                  name="colaboradoIntegracaoAlternativoId"
                  value={initialValue ? initialValue.colaboradoIntegracaoAlternativoNome : ''}
                  disabled
                />
              </Col>
              <Col span={1}>
                <ModalColaborador
                  colaboradorTableProps={listColaboradores}
                  definirValorColoborador={(value) => {
                    if (value) {
                      onChangeInicialValue(value, ColaboradoIntegracaoOuColaboradoIntegracaoAlternativo.ColaboradoIntegracaoAlternativo);
                    }
                  }}
                />
              </Col>

            </Row>

          </Widget>

          <Widget title="Resultado">
            <Table
              id={'tabelaAprovadorAlternativo'}
              rowKey="id"
              columns={colluns()}
              dataSource={listResult}
             
            />
          </Widget>
        </MasterDetailForm>

      </GridView>
    </SimpleView>

  </>)

}

export default AprovadorAlternativo;